// extracted by mini-css-extract-plugin
export default {"faithSection":"FaithStatement_faithSection__dhpjM","faithStatement":"FaithStatement_faithStatement__4FBEz"};